import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  TextField,
} from '@mui/material';
import { CANCELLATION_TYPES } from 'constants/order/cancellationTypes';

export const CancelOrderOptions = ({ setType, setMessage, type, message }) => {
  return (
    <Box className="cancellation-options-container">
      <FormControl className="form">
        <Typography className="sub-title" variant="h6">
          Reason for canceling
        </Typography>

        <RadioGroup
          onChange={(e, value) => {
            setMessage(null);
            setType(value);
          }}
          value={type}
        >
          <FormControlLabel
            componentsProps={{ typography: { className: 'label' } }}
            value={CANCELLATION_TYPES.NO_LONGER_NEEDED}
            control={<Radio />}
            label="Service no longer needed"
          />

          <FormControlLabel
            componentsProps={{ typography: { className: 'label' } }}
            value={CANCELLATION_TYPES.BY_MISTAKE}
            control={<Radio />}
            label="Order created by mistake"
          />

          <FormControlLabel
            componentsProps={{ typography: { className: 'label' } }}
            value={CANCELLATION_TYPES.DELIVERY_ISSUE}
            control={<Radio />}
            label="Pickup/Delivery time no longer works"
          />
          <FormControlLabel
            componentsProps={{ typography: { className: 'label' } }}
            value={CANCELLATION_TYPES.CUSTOM}
            control={<Radio />}
            label="Other"
          />
          {type === CANCELLATION_TYPES.CUSTOM ? (
            <div className="custom-type-input">
              <Typography className="custom-reason-title" variant="h3">
                Please tell us your reason (optional)
              </Typography>
              <TextField
                label="Other"
                multiline
                rows={2}
                variant="outlined"
                fullWidth
                onChange={(event) => setMessage(event.target.value)}
                style={{ borderColor: 'black' }}
                value={message}
              />
            </div>
          ) : null}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

CancelOrderOptions.propTypes = {
  type: PropTypes.string,
  setType: PropTypes.func.isRequired,
  message: PropTypes.string,
  setMessage: PropTypes.func.isRequired,
};
